/**
 * <h4>Send track user events<h4/>
 *
 * The Tracker module is responsible for transmitting user event tracking data. <br/>
 * A customer account configuration is required for use. The methods should be executed when the appropriate event occurs.<br/>
 * It is very important to send correct data because system Qon uses it to wyznaczania products in recommendations frames.
 * @packageDocumentation
 */

export {Tracker as TrackerInterface} from './Tracker'
export {TrackerImpl as Tracker} from './TrackerImpl'
export {Transaction} from './IO/Input/Transaction'
export {TransactionPosition} from './IO/Input/TransactionPosition'
export {ProductClick} from './IO/Input/ProductClick'
export {ProductView} from './IO/Input/ProductView'


/** @module */
export * as Error from './IO/Output/Error/'
